import * as React from "react";
import { observer } from "mobx-react";
import { MDBBtn, MDBCol } from "mdbreact";
import { Alert, Button, Classes, FormGroup, H5, HTMLSelect, InputGroup, Intent, Popover, TextArea } from "@blueprintjs/core";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { toast } from "react-toastify";
import { SpedEfdStore } from "../../stores/sped/SpedEfdStore";
import { newIEntradaCFOP } from "../../model";
import { Pager } from "../utils/Pager";
import { observable } from "mobx";

const InputMask = require("react-input-mask");

@observer
export default class CfopEntrada extends React.Component<{}, {}> {

    obs = observable({
        open_adiciona_cfop_entrada: false as boolean,
        open_adiciona_cfops_saida: false as boolean,
        open_adiciona_cst_saida: false as boolean
    })

    constructor(props: any) {
        super(props);
    }

    async handleBuscaCFOPEntrada(e) {
        SpedEfdStore.obs.input_cfop_entrada = e
        let data = e?.replace(/\_/g, "").replace(/\-/g, "")

        if (data.length == 4) {
            let validaCFOP = await SpedEfdStore.cfopsCadastrados(SpedEfdStore.obs.tab_entrada_saida, SpedEfdStore.obs.config_id);

            if (validaCFOP.indexOf(data) > -1) {
                toast.warning('CFOP já cadastrado', {});
                return;
            }
            await SpedEfdStore.handleBuscaCfopEntrada(e)
        }
    }

    async handleBuscaCFOPSaida(e) {
        SpedEfdStore.obs.input_cfop_saida = e
        let data = e?.replace(/\_/g, "").replace(/\-/g, "")

        if (data.length == 4) {
            await SpedEfdStore.handleBuscaCfopsSaida(e)
        }
    }

    async handleSaveCfopEntrada() {

        let copy2 = Object.assign({}, SpedEfdStore.obs.cfop_entrada)

        copy2.cfop_entrada = SpedEfdStore.obs.cfop_entrada.cfop_entrada.codigo ? SpedEfdStore.obs.cfop_entrada.cfop_entrada.codigo : SpedEfdStore.obs.cfop_entrada.cfop_entrada
        copy2.cfops_saida = SpedEfdStore.obs.cfop_entrada.cfops_saida?.map(x => x.codigo)
        copy2.csts_selecionados = SpedEfdStore.obs.cfop_entrada.csts_selecionados?.map(x => x.codigo)
        copy2.config_id = SpedEfdStore.obs.config_id


        if (copy2.cfop_entrada == "") {
            toast.warning('CFOP de Entrada Obrigatório!', {});
            return;
        }

        if (copy2.cfops_saida.length == 0) {
            toast.warning('Adicione pelo menos um CFOP de Saída!', {});
            return;
        }

        if (copy2.cst_saida == "selecione") {
            if (copy2.csts_selecionados.length == 0) {
                toast.warning('Selecione um CST ou mude para Todos', {});
                return;
            }
        }

        if (!SpedEfdStore.obs.isEdit) {
            await SpedEfdStore.handleSaveCfop(copy2)
        } else {
            await SpedEfdStore.handleUpdateCfop(copy2)
        }
    }

    handleAdicionaCFOPSaida() {
        this.obs.open_adiciona_cfops_saida = false
    }

    handleAdicionaCST() {
        this.obs.open_adiciona_cst_saida = false
    }

    async handleInserirCFOP() {
        let cfop_saida = SpedEfdStore.obs.input_cfop_saida?.replace(/\-/g, "").replace(/\_/g, "")

        if (cfop_saida == "") {
            toast.warning('CFOP Inválido', {});
            return;
        }

        let validaCFOP = SpedEfdStore.obs.cfop_entrada.cfops_saida?.map(value => {
            return value.codigo;
        });

        if (validaCFOP.indexOf(cfop_saida) > -1) {
            toast.warning('CFOP já cadastrado', {});
            return;
        } else {
            SpedEfdStore.obs.cfop_entrada.cfops_saida = [...SpedEfdStore.obs.cfop_entrada.cfops_saida, { codigo: cfop_saida, descricao: SpedEfdStore.obs.cfop_saida_descricao }];
            toast.success('CFOP inserido com sucesso', {});
            SpedEfdStore.obs.input_cfop_saida = ""
            SpedEfdStore.obs.cfop_saida_descricao = ""
            SpedEfdStore.obs.cfops_selecionados = SpedEfdStore.obs.cfop_entrada.cfops_saida?.map(value => {
                return value.codigo;
            });
        }
    }

    hanldeDeleteRowCFOP(codigo: string) {
        SpedEfdStore.obs.cfop_entrada.cfops_saida = SpedEfdStore.obs.cfop_entrada.cfops_saida.filter(
            (item: any) => {
                return item.codigo != codigo;
            },
        );
        SpedEfdStore.obs.cfops_selecionados = SpedEfdStore.obs.cfop_entrada.cfops_saida?.map(value => {
            return value.codigo;
        });
    }

    async handleInserirCST() {
        if (SpedEfdStore.obs.cst == 'selecione') {
            toast.warning('Selecione um CST', {});
            return
        }

        let cst = SpedEfdStore.obs.cst.split("-")[1].replace(/\ /g, "")
        let cst_descricao = SpedEfdStore.obs.cst.split("-")[2]

        let validaCST = SpedEfdStore.obs.cfop_entrada.csts_selecionados?.map(value => {
            return value.codigo;
        });

        if (validaCST.indexOf(cst) > -1) {
            toast.warning('CST já cadastrado', {});
            return;
        } else {
            SpedEfdStore.obs.cfop_entrada.csts_selecionados = [...SpedEfdStore.obs.cfop_entrada.csts_selecionados, { codigo: cst, descricao: cst_descricao }];
            toast.success('CST inserido com sucesso', {});
            SpedEfdStore.obs.cst = 'selecione'
            SpedEfdStore.obs.csts_selecionados = SpedEfdStore.obs.cfop_entrada.csts_selecionados?.map(value => {
                return value.codigo;
            });
        }
    }

    hanldeDeleteRowCST(codigo: string) {
        SpedEfdStore.obs.cfop_entrada.csts_selecionados = SpedEfdStore.obs.cfop_entrada.csts_selecionados.filter(
            (item: any) => {
                return item.codigo != codigo;
            },
        );
        SpedEfdStore.obs.csts_selecionados = SpedEfdStore.obs.cfop_entrada.csts_selecionados?.map(value => {
            return value.codigo;
        });
    }

    handleSelectCSTs(e) {
        SpedEfdStore.obs.cfop_entrada.cst_saida = e
        if (e == "todos") {
            SpedEfdStore.obs.cfop_entrada.csts_selecionados = []
        }
    }

    async handleEditCFOPEntrada(row: any) {
        SpedEfdStore.obs.isEdit = true

        SpedEfdStore.obs.cfop_entrada = row
        SpedEfdStore.obs.input_cfop_entrada = row.cfop_entrada.codigo
        SpedEfdStore.obs.cfop_entrada_descricao = row.cfop_entrada.descricao

        SpedEfdStore.obs.cfops_selecionados = row.cfops_saida?.map(value => value.codigo)
        SpedEfdStore.obs.csts_selecionados = row.csts_selecionados?.map(value => value.codigo)

        this.obs.open_adiciona_cfop_entrada = true
    }

    async handleClose() {
        SpedEfdStore.obs.input_cfop_saida = ""
        SpedEfdStore.obs.input_cfop_entrada = ""
        SpedEfdStore.obs.cfop_saida_descricao = ""
        SpedEfdStore.obs.cfop_entrada_descricao = ""
        SpedEfdStore.obs.cfops_selecionados = ""
        SpedEfdStore.obs.csts_selecionados = ""
        SpedEfdStore.obs.cst = "selecione"
        SpedEfdStore.obs.cfop_entrada = newIEntradaCFOP()
        await SpedEfdStore.loadCfops(SpedEfdStore.obs.tab_entrada_saida, 1, SpedEfdStore.obs.config_id);
        SpedEfdStore.obs.cfops_current = 1
        SpedEfdStore.obs.isEdit = false
        this.obs.open_adiciona_cfop_entrada = false
    }

    handleChangePage(e: any) {
        SpedEfdStore.loadCfops("entrada", SpedEfdStore.obs.cfops_current, SpedEfdStore.obs.config_id)
    }

    handleIncluirCfopEntrada() {
        SpedEfdStore.obs.isEdit = false
        this.obs.open_adiciona_cfop_entrada = true
    }

    render() {

      if(SpedEfdStore.obs.selectedEmpresa.cfop_calculo_sped){

        return this.renderAutomatico()

      }

      return this.renderNormal()

    }

    renderAutomatico() {
      
      return (
        
        <MDBCol>
        
        <h5>CFOP Cálculo Automático Ativado!</h5>
        
        </MDBCol>

      )

    }

    renderNormal() {

        const formaterDetalhes = (cell, row) => {
            return (
                <>
                    <MDBBtn color="default" rounded size="sm" onClick={() => this.handleEditCFOPEntrada(row.items)}>
                        <img src="/images/configuration.png" width={25} />
                    </MDBBtn>

                    <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
                        <MDBBtn color="default" rounded size="sm">
                            <img src="/images/bin.png" width={25} />
                        </MDBBtn>
                        <div>
                            <H5>Confirmar exclusão</H5>
                            <p style={{ fontSize: 12 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: 15,
                                }}
                            >
                                <Button
                                    className={Classes.POPOVER_DISMISS}
                                    style={{ marginRight: 10 }}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    intent="danger"
                                    className={Classes.POPOVER_DISMISS}
                                    onClick={() => SpedEfdStore.handleDeleteCfop(row.id, row.codigo, row.cfops_saida)}
                                >
                                    Excluir
                                </Button>
                            </div>
                        </div>
                    </Popover>

                </>
            )
        }

        const formatterRowDeleteCFOPSaida = (cell, row) => {
            return (
                <MDBBtn color="default" rounded size="sm" onClick={() => this.hanldeDeleteRowCFOP(row.codigo)}>
                    <img src="/images/bin.png" width={25} />
                </MDBBtn>
            )
        }

        const formatterRowDeleteCST = (cell, row) => {
            return (
                <MDBBtn color="default" rounded size="sm" onClick={() => this.hanldeDeleteRowCST(row.codigo)}>
                    <img src="/images/bin.png" width={25} />
                </MDBBtn>
            )
        }

        let cstOptions = SpedEfdStore.obs.index_csts?.map((value: any) => {
            return (
                <option value={`${value.id} - ${value.codigo} - ${value.descricao}`}>
                    {`${value.codigo} - ${value.descricao}`}
                </option>
            )
        }
        );

        cstOptions.unshift(
            <option value={"selecione"}>{"Selecione o CST"}</option>
        );

        let cfop_entrada = SpedEfdStore.obs.index_cfops?.map(obj => {
            return (
                {
                    id: obj._id || obj.id,
                    codigo: obj.cfop_entrada?.codigo || obj.cfop_entrada?.map(value => value.codigo),
                    descricao: obj.cfop_entrada?.descricao,
                    cfops_saida: obj.cfops_saida?.map(value => value.codigo),
                    cst_saida: obj.cst_saida,
                    csts_selecionados: obj.csts_selecionados?.map(value => value.codigo),
                    items: obj
                }
            );
        })

        return (
            <>
                <MDBCol>
                    <MDBBtn
                        className="btnDefault btnBuscarNfe"
                        style={{ marginRight: 20, float: "left", marginBottom: 20 }}
                        onClick={() => this.handleIncluirCfopEntrada()}
                    >
                        Incluir
                    </MDBBtn>

                    <BootstrapTable
                        data={cfop_entrada}
                    >
                        <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                        <TableHeaderColumn dataField="codigo" width="15%">CFOP entradas</TableHeaderColumn>
                        <TableHeaderColumn dataField="descricao" width="70%">Descrição</TableHeaderColumn>
                        <TableHeaderColumn dataField="cfops_saida" width="20%">CFOPs saidas</TableHeaderColumn>
                        <TableHeaderColumn dataField="cst_saida" width="20%">CSTs saidas</TableHeaderColumn>
                        <TableHeaderColumn dataField="csts_selecionados" width="20%">CSTs selecionados</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={formaterDetalhes} width="15%"></TableHeaderColumn>
                    </BootstrapTable>
                </MDBCol>
                
                <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                    <Pager
                        currentPage={SpedEfdStore.obs.cfops_current}
                        totalCount={SpedEfdStore.obs.cfops_length}
                        pageSize={5}
                        onPageChange={(page) => this.handleChangePage(SpedEfdStore.obs.cfops_current = page)}
                    />
                </div>

                <Alert
                    cancelButtonText="Cancelar"
                    confirmButtonText={"Salvar"}
                    isOpen={this.obs.open_adiciona_cfop_entrada}
                    onClose={() => this.handleClose()}
                    onConfirm={() => this.handleSaveCfopEntrada()}
                    canOutsideClickCancel={true}
                    className="AlertUser"
                    intent={Intent.PRIMARY}
                >
                    {!SpedEfdStore.obs.isEdit ?
                        <h2 className="titleSEFAZ">Adicionar CFOP</h2>
                        :
                        <h2 className="titleSEFAZ">Editar CFOP</h2>
                    }

                    <FormGroup label="CFOP Entrada">
                        <InputMask
                            mask="9-999"
                            defaultValue={SpedEfdStore.obs.input_cfop_entrada}
                            className={SpedEfdStore.obs.isEdit ? "form-control inputDisabled" : "form-control"}
                            onChange={(e) => this.handleBuscaCFOPEntrada(e.target.value)}
                            disabled={SpedEfdStore.obs.isEdit}
                        />
                    </FormGroup>

                    <FormGroup label="Descrição">
                        <TextArea style={{ width: "100%" }} disabled value={SpedEfdStore.obs.cfop_entrada_descricao} />
                    </FormGroup>

                    <div style={{ display: "flex" }}>
                        <div style={{ width: "90%" }}>
                            <FormGroup label="CFOPs Saida">
                                <InputGroup disabled value={SpedEfdStore.obs.cfops_selecionados} />
                            </FormGroup>
                        </div>
                        <div style={{ width: "10%", textAlign: "center", marginTop: "25px" }}>
                            <MDBBtn color="default" size="sm" onClick={() => this.obs.open_adiciona_cfops_saida = true}>
                                <img src="/images/configuration.png" width={25} />
                            </MDBBtn>
                        </div>
                    </div>

                    <FormGroup label="CSTs Saída">
                        <HTMLSelect
                            onChange={e => this.handleSelectCSTs(e.target.value)}
                            value={SpedEfdStore.obs.cfop_entrada.cst_saida}
                        >
                            <option value="selecione">Selecionar</option>
                            <option value="todos">Todos</option>
                        </HTMLSelect>
                    </FormGroup>

                    <div style={{ display: "flex" }}>
                        <div style={{ width: "90%" }}>
                            <FormGroup label="CSTs Selecionados">
                                <InputGroup disabled value={SpedEfdStore.obs.csts_selecionados} />
                            </FormGroup>
                        </div>
                        <div style={{ width: "10%", textAlign: "center", marginTop: "25px" }}>
                            <MDBBtn color="default" size="sm" onClick={() => this.obs.open_adiciona_cst_saida = true} disabled={SpedEfdStore.obs.cfop_entrada.cst_saida == "todos"}>
                                <img src="/images/configuration.png" width={25} />
                            </MDBBtn>
                        </div>
                    </div>

                </Alert>

                <Alert
                    cancelButtonText="Fechar"
                    confirmButtonText="Adicionar"
                    isOpen={this.obs.open_adiciona_cfops_saida}
                    onClose={() => this.obs.open_adiciona_cfops_saida = false}
                    onConfirm={() => this.handleAdicionaCFOPSaida()}
                    canOutsideClickCancel={true}
                    intent={Intent.PRIMARY}
                    className="AlertUser"
                >
                    <div style={{ marginBottom: "60px" }}>

                        <h2 className="titleSEFAZ">Adicionar CFOP Saída</h2>
                        <div style={{ display: "flex" }}>
                            <FormGroup label="CFOPs Saída" style={{ width: "200px" }}>
                                <InputMask
                                    mask="9-999"
                                    value={SpedEfdStore.obs.input_cfop_saida}
                                    className="form-control"
                                    onChange={(e) => this.handleBuscaCFOPSaida(e.target.value)}
                                />
                            </FormGroup>
                            <div style={{ marginTop: "26px" }}>
                                <MDBBtn className="btnDefault btnBuscarNfe"
                                    onClick={() => this.handleInserirCFOP()}
                                    style={{ marginLeft: 20 }}
                                >
                                    Inserir
                                </MDBBtn>
                            </div>
                        </div>
                        <FormGroup label="Descrição">
                            <TextArea style={{ width: "100%" }} disabled value={SpedEfdStore.obs.cfop_saida_descricao} />
                        </FormGroup>

                        <BootstrapTable
                            className="dados-recolhimento"
                            data={SpedEfdStore.obs.cfop_entrada.cfops_saida}
                        >
                            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                            <TableHeaderColumn dataField="codigo" width="50%">CFOP Saida</TableHeaderColumn>
                            <TableHeaderColumn dataField="descricao" width="50%">Descrição</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={formatterRowDeleteCFOPSaida} width="20%"></TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </Alert>

                <Alert
                    cancelButtonText="Fechar"
                    confirmButtonText="Adicionar"
                    isOpen={this.obs.open_adiciona_cst_saida}
                    onClose={() => this.obs.open_adiciona_cst_saida = false}
                    onConfirm={() => this.handleAdicionaCST()}
                    canOutsideClickCancel={true}
                    intent={Intent.PRIMARY}
                    className="AlertUser"
                >
                    <div style={{ marginBottom: "60px" }}>
                        <h2 className="titleSEFAZ">Adicionar CST</h2>

                        <div style={{ display: "flex" }}>
                            <div style={{ width: "90%" }}>
                                <HTMLSelect
                                    onChange={e => SpedEfdStore.obs.cst = e.target.value}
                                    value={SpedEfdStore.obs.cst}
                                >
                                    {cstOptions}
                                </HTMLSelect>
                            </div>
                            <div>
                                <MDBBtn className="btnDefault btnBuscarNfe"
                                    onClick={() => this.handleInserirCST()}
                                    style={{ marginLeft: 20 }}
                                >
                                    Inserir
                                </MDBBtn>
                            </div>
                        </div>

                        <BootstrapTable
                            className="dados-recolhimento"

                            data={SpedEfdStore.obs.cfop_entrada.csts_selecionados}
                        >
                            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                            <TableHeaderColumn dataField="codigo" width="50%">CST</TableHeaderColumn>
                            <TableHeaderColumn dataField="descricao" width="50%">Descrição</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={formatterRowDeleteCST} width="20%"></TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </Alert>
            </>
        )
    }
}